import { Avatar } from '@cian/ui-kit/avatar';
import { UIHeading4, UIText3 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './BrandingBanner.css';

interface IBrandingBannerProps {
  logoSrc?: string | null;
  title: string;
  subtitle?: string | null;
}

export const BrandingBanner: React.VFC<IBrandingBannerProps> = ({ logoSrc, title, subtitle }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['avatar']}>
        <Avatar type="agency" size={40} src={logoSrc} />
      </div>
      <div className={styles['content']}>
        <UIHeading4>{title}</UIHeading4>
        {subtitle && <UIText3 color="gray60_100">{subtitle}</UIText3>}
      </div>
    </div>
  );
};
